import styled from 'styled-components';
import { layout } from 'styles/layout'

const confettiShapeBlueRhombus = 'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjYiIGhlaWdodD0iMjkiIHZpZXdCb3g9IjAgMCAyNiAyOSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTEyLjEyODkgMjguNjg2TDAuNzE4OTYyIDIxLjM5MjlMMTQuMTgzMiAwLjMyODM4MkwxNy45Njc0IDE5LjU1MThMMTIuMTI4OSAyOC42ODZaIiBmaWxsPSIjMUNBQkJGIi8+Cjwvc3ZnPgo=';
const confettiShapeOrangeHexagon = 'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjgiIGhlaWdodD0iMjgiIHZpZXdCb3g9IjAgMCAzNSAzNSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTIzLjIzNzkgMzQuMzkyNUwzMS4wNDQ2IDE5LjExODlMMjcuNzAzNyA4Ljg3MTA1TDEyLjM1MzcgMS4wMDYzMUw0LjMzNzQ0IDE2LjQ4ODdMNy41ODgwMSAyNi40NTk2TDIzLjIzNzkgMzQuMzkyNVoiIGZpbGw9IiNGRjcwNjIiLz4KPC9zdmc+Cg==';
const confettiShapePlumRhombus = 'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjgiIGhlaWdodD0iMjEiIHZpZXdCb3g9IjAgMCAyOCAyMSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTI3LjAyNCAxNy43NTEzTDcuMTEzODEgMi4yMDk5OUwwLjg5NzMxMyAxMC4xNzRMMS45MjUyOCAxOC41MTU2TDI3LjAyNCAxNy43NTEzWiIgZmlsbD0iIzk2MzQ4MSIvPgo8L3N2Zz4K';

export const ConfettiWrapper = styled.div`
  max-width: 100vw !important;
  background:
    url(${confettiShapeBlueRhombus}) 7% 15% no-repeat,
    url(${confettiShapeOrangeHexagon}) 97% 35% / 25px auto no-repeat;

  @media screen and (min-width: ${layout.subLg}) {
    background:
      url(${confettiShapeBlueRhombus}) 7% 15% no-repeat,
      url(${confettiShapeOrangeHexagon}) 90% 25% no-repeat,
      url(${confettiShapePlumRhombus}) 15% 70% no-repeat;
  }
`

export const BannerWrapper = styled.div`
  display: grid;
  row-gap: 0.75rem;
  padding: 4em 0em 2em 0em;
`

export const BannerHeadingContainer = styled.div`
  justify-self: center;

  & > h1 {
    line-height: 1.4em;
  }
`

export const BannerParagraphContainer = styled.div`
  max-width: 740px;
  padding: 0rem 1.5rem;
  justify-self: center;
  box-sizing: border-box;
`
